<template>
    <div class="visualizar-pdf-wrapper">
        <div 
            v-if="url" 
            class="pdf-viewer-container"
        >
            <div
                v-if="nomeArquivo"
                class="pdf-file-name"
                :title="nomeArquivo"
            >
                {{ nomeArquivo }}
            </div>
            <iframe
                :src="urlVisualizacao"
                :width="`${width}%`"
                :height="`${height}px`"
                :frameborder="frameborder"
            ></iframe>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        url: {
            type: String,
            default: '',
        },
        nomeArquivo: {
            type: String,
            default: '',
        },
        zoom: {
            type: Number,
            default: 100,
        },
        width: {
            type: Number,
            default: 100,
        },
        height: {
            type: Number,
            default: 800,
        },
        frameborder: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        urlVisualizacao() {
            if (!this.url) return '';

            const [urlSemFragmento] = this.url.split('#');
            return `${urlSemFragmento}#toolbar=0&zoom=${this.zoom}`;
        },
    },
}
</script>
<style scoped>
.visualizar-pdf-wrapper {
    background-color: #f4f4f4;
    padding: 20px;
    width: 100%;
}
.pdf-viewer-container {
    width: 100%;
}
.pdf-viewer-container iframe {
    display: block;
}
.pdf-file-name {
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #2d3439;
    word-break: break-all;
}
@media print {
    .no-print {
        display: none !important;
    }
}
</style>